import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { layersByLocationSelector, logosSelector, selectedLogoIdSelector } from '../../../../../../../../redux/logo/logo.selectors';
import { isSamplePromoSelector, isLimitedEditionSelector, productIdSelector, shouldShowLaserEngravedPopupInCaseEmbellishmentMethodIsOnlyLaserEngravedSelector } from '../../../../../../../../redux/product/product.selectors';
import { bringForward, sendBackward, setInitialLogoRect, selectLogo, updateLogoDimensions, removeLogo } from '../../../../../../../../redux/logo/logo.actions';
import { showDebossedPopupAction } from '../../../../../../../../redux/debossed-popup/debossed-popup.actions';
import { showLaserEngravedPopupAction } from '../../../../../../../../redux/laser-engraved-popup/laser-engraved-popup.actions';
import { shouldShowDebossedPopupInCaseEmbellishmentMethodIsOnlyDebossedSelector } from '../../../../../../../../redux/product/product.selectors';
import { MediaEditorComponent } from './media-editor';
const propsSelector = (_, props) => props;
export const singleLogoSelector = createSelector(logosSelector, propsSelector, (logos, props) => logos[props.mediaId] || {});
const mediaEditorSelector = () => createSelector(selectedLogoIdSelector, layersByLocationSelector, singleLogoSelector, isSamplePromoSelector, isLimitedEditionSelector, shouldShowDebossedPopupInCaseEmbellishmentMethodIsOnlyDebossedSelector, shouldShowLaserEngravedPopupInCaseEmbellishmentMethodIsOnlyLaserEngravedSelector, productIdSelector, (selectedLogo, layers, media, isSamplePromo, isLimitedEdition, shouldShowDebossedPopupInCaseEmbellishmentMethodIsOnlyDebossed, shouldShowLaserEngravedPopupInCaseEmbellishmentMethodIsOnlyLaserEngraved, productId) => ({
  showLayerButton: layers && layers.length > 1,
  media,
  showRemoveButton: !isSamplePromo,
  selectedLogo,
  isLimitedEdition,
  shouldShowDebossedPopupInCaseEmbellishmentMethodIsOnlyDebossed,
  shouldShowLaserEngravedPopupInCaseEmbellishmentMethodIsOnlyLaserEngraved,
  productId
}));
const mediaEditorDispatcher = dispatch => ({
  onLogoDelete: id => {
    dispatch(removeLogo(id));
  },
  onLogoSelect: mediaId => {
    dispatch(selectLogo(mediaId));
  },
  onLogoLoad: (image, imprintArea, logoId) => {
    const {
      width,
      height
    } = image.getBoundingClientRect();
    dispatch(setInitialLogoRect({
      logoParams: {
        originalLogoHeight: height,
        originalLogoWidth: width
      },
      imprintArea,
      logoId
    }));
  },
  onBringForwardLayer: id => {
    dispatch(bringForward(id));
  },
  onSendBackwardLayer: id => {
    dispatch(sendBackward(id));
  },
  onDimensionsChange: ({
    rect,
    mediaId,
    type
  }) => {
    dispatch(updateLogoDimensions({
      rect,
      mediaId,
      type,
      isLogoDimensionsManuallyModified: true
    }));
  },
  showDebossedPopup: productId => dispatch(showDebossedPopupAction(productId)),
  showLaserEngravedPopup: productId => dispatch(showLaserEngravedPopupAction(productId))
});
export const MediaEditor = connect(mediaEditorSelector, mediaEditorDispatcher)(MediaEditorComponent);